import { render, staticRenderFns } from "./GalleryIndexPagination.vue?vue&type=template&id=bf360d82&"
import script from "./GalleryIndexPagination.vue?vue&type=script&lang=js&"
export * from "./GalleryIndexPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports